module.exports = __webpack_public_path__ + "img/guide_du_voyageur.a1d2b203.svg";